export type TreeNodeType =
  | "tenant"
  | "company"
  | "department"
  | "role"
  | "employee"
  | "asset";

// The node palette, and the words for it. Both the graph and the legend read these, so a colour can
// never mean one thing in the tree and another in the key beside it — the failure a hand-copied legend
// invites the first time a colour is tuned.
export const NODE_COLORS: Record<TreeNodeType, string> = {
  tenant: "#8C8C8C",
  company: "#5F95FF",
  department: "#3ABAB4",
  role: "#E67E22",
  employee: "#9B59B6",
  // Deliberately not a red: this estate reads red as an alarm, and an asset is an ordinary thing.
  asset: "#2C3E50",
};

export const NODE_LABELS: Record<TreeNodeType, string> = {
  tenant: "Tenant",
  company: "Company",
  department: "Department",
  role: "Role",
  employee: "Employee",
  // Just "Asset". Each node already carries its own type on its rank line — Tanker, Aircraft, Site —
  // so spelling examples out in the key repeated what the tree says better.
  asset: "Asset",
};

// Legend order follows the descent: tenant → company → department → role → employee, with assets last
// because they hang off the COMPANY alongside departments rather than continuing that chain.
export const NODE_LEGEND_ORDER: TreeNodeType[] = [
  "tenant",
  "company",
  "department",
  "role",
  "employee",
  "asset",
];

export interface CompanyTreeItem {
  readonly uid: string;
  readonly parentCompanyUid?: string;
  readonly parentUid?: string;
  readonly name: string;
  readonly rank: string;
  readonly nodeType: TreeNodeType;
  readonly expandableCount: number;
  readonly subCompaniesCount: number;
  readonly departmentsCount: number;
  readonly departmentUid?: string;
  readonly roleUid?: string;
  readonly tenantUid?: string;
  readonly dataItem?: any;
}
